import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing, palette }) =>
  createStyles({
    container: {
      height: '100%',
      paddingTop: spacing(3),
      paddingBottom: spacing(3),

      display: 'grid',
      gridTemplateRows: 'min-content 1fr',
      '& form': {
        display: 'flex',
        flex: 1,
      },
    },
    upper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& h1': {
        fontWeight: 600,
        width: '20%',
        maxWidth: '18rem',
        minWidth: 'fit-content',
        marginRight: '1rem',
      },
      '& .MuiTextField-root': {
        flex: 1,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '4px 0 0 4px',
      },
    },
    button: {
      width: 'auto',
      minWidth: 'max-content',
      paddingInline: '1.6rem',
      gap: '0.8rem',
    },
    searchButton: {
      width: 'auto',
      height: '4.8rem',
      margin: 0,
      padding: '0 2.7rem',

      backgroundColor: palette.background.default,

      border: `1px solid ${palette.secondary.light}`,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    inputLabelNoShrink: {
      '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink):not(.MuiInputLabel-marginDense)':
        {
          transform: 'translate(4.8rem, 1.6rem) scale(1)',
        },
    },
    inputLabel: {
      maxWidth: '80rem',
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: 0,
      },
    },
  }),
)
